<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="updateStatus"
    @close="$emit('close')"
  />
</template>

<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';
import EventBus from '@/event-bus';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    whatsappTemplate: {
      type: Object,
      required: true,
    },
    status: {
      type: String,
      required: true,
      validator: (value) => ['APPROVED', 'REJECTED'].includes(value),
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      const action = this.status === 'APPROVED' ? 'aprobar' : 'rechazar';
      return `¿Está seguro de que desea ${action} la plantilla "${this.whatsappTemplate.name}"? Esta acción no se puede deshacer.`;
    },
  },
  methods: {
    updateStatus() {
      this.axios.patch(`whatsapp_templates/${this.whatsappTemplate.id}/status`, {
        status: this.status,
      })
        .then(() => {
          this.$emit('updated');
          this.$emit('close');
        })
        .catch((error) => {
          console.error(error);
          const message = (error.response && error.response.data && error.response.data.message)
            || 'Ocurrió un error al actualizar el estado de la plantilla';
          EventBus.$emit('error', message);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/WhatsappTemplates/UpdateStatusWhatsappTemplateDialog.vue